import React, { useEffect, useState } from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { AccordionHeaderTitle } from 'component/Accordion';
import { Map } from 'component/Map';
import { pointGeometryToMapGeojson } from 'utils/Helper';
import { CommentDisplay } from 'component/CommentBlock';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';
import { PolygonInfoView } from './PolygonInfo';
import { LmBmTableView } from './LmBmTable';
import { TableFileInfo } from '../../blocks/FileInformation/TableInfo';

export const FileInfoView = (props) => {
  const { formData, comments, translatedFormData, translateState } = props;
  const [lmGeojson, setLmGeojson] = useState(formData?.info?.lm?.geometry);
  const [bmGeojson, setBmGeojson] = useState(formData?.info?.bm?.geometry);
  const fileZone = formData?.info?.general?.file_zone ?? formData?.file_zone;

  const haReportsHook = useHAReports(props?.turnPointsMap);
  const haReports = props?.haReports || haReportsHook;
  useBufferZone(props?.turnPointsMap);

  useEffect(() => {
    if (formData?.info?.lm?.geometry?.coordinates?.length) {
      setLmGeojson(
        pointGeometryToMapGeojson(
          formData.info.lm.geometry.coordinates,
          fileZone
        )
      );
    }
  }, [formData?.info?.lm?.geometry, fileZone]);

  useEffect(() => {
    if (formData?.info?.bm?.geometry?.coordinates?.length) {
      setBmGeojson(
        pointGeometryToMapGeojson(
          formData.info.bm.geometry.coordinates,
          fileZone
        )
      );
    }
  }, [formData?.info?.bm?.geometry, fileZone]);

  return (
    <AccordionItem uuid="fileInfo">
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId="5"
            titleUA="Інформація про полігон"
            titleEN="File information"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="flex-column-group">
          <PolygonInfoView formData={formData} />
          <div className="accordion-body-wrapper bgGrey">
            <LmBmTableView
              formData={formData}
              translatedFormData={translatedFormData}
              translateState={translateState}
            />
          </div>

          <TableFileInfo formData={formData} />
          <div style={{ position: 'relative' }}>
            <HASwitchers
              {...haReports}
              googleWms={true}
              style={{
                position: 'absolute',
                top: '66px',
                zIndex: 1,
                background: 'rgba(255, 255, 255, 0.8)',
                borderRadius: '4px',
                padding: '0px 15px 7px 10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                left: '0px',
                borderRadius: '0 0 8px',
                boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
              }}
            />

            <Map
              map={props?.turnPointsMap}
              setMap={props?.setTurnPointsMap}
              id="polygon-map"
              turnPointsPolygon={formData?.info?.turn_points?.geojson}
              hazardAreaType={formData?.info?.general?.hazard_area_type}
              lmGeojson={lmGeojson}
              bmGeojson={bmGeojson}
              haReportsPolygons={haReports?.haReportsPolygons}
              // azureLayerEnabled={haReports?.azureLayerEnabled}
              // setAzureLayerEnabled={haReports?.setAzureLayerEnabled}
              googleWms
            />
          </div>
          <CommentDisplay comments={comments} block="polygon_info" />
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};
